export const epasUrl = `epas`
export const assessmentsUrl = `${epasUrl}/bewertungen`
export const externalAssessmentsUrl = `${epasUrl}/fremdbewertungen`
export const externalAssessmentRequestsUrl = `${externalAssessmentsUrl}/anfragen`